import {
  Toolbar,
  Box,
  List,
  ListSubheader,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Chip,
  Divider,
  Drawer,
  Dialog,
  Slide,
  Grow,
  IconButton,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import RuleOutlinedIcon from "@mui/icons-material/RuleOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { RegionContext } from "../RegionContext";
import React, { useEffect, useState, useContext } from "react";
import LockPersonOutlinedIcon from "@mui/icons-material/LockPersonOutlined";
import DataObjectOutlinedIcon from "@mui/icons-material/DataObjectOutlined";
import CloseIcon from "@mui/icons-material/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Grow style={{ transformOrigin: "0 0 0" }} ref={ref} {...props} />;
});

function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const { data, setData } = useContext(RegionContext);

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/#overview");
    }
  }, []);

  const closeDrawer = () => {
    setData((prevState) => ({
      ...prevState,
      drawer_open: false,
    }));
  };

  const topList = () => {
    return (
      <List
        dense
        sx={{ width: "100%" }}
        component="nav"
        subheader={
          <ListSubheader className="label-caps" id="nested-list-subheader">
            Introduction
          </ListSubheader>
        }
      >
        <Link onClick={closeDrawer} to="/#overview">
          <ListItemButton selected={`/${location.hash}` === "/#overview"}>
            <ListItemIcon>
              <HandshakeOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Overview" />
          </ListItemButton>
        </Link>

        <Link onClick={closeDrawer} to="/#purpose">
          <ListItemButton selected={`/${location.hash}` === "/#purpose"}>
            <ListItemIcon>
              <ListAltOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Purpose" />
          </ListItemButton>
        </Link>

        <Link onClick={closeDrawer} to="/#introduction">
          <ListItemButton selected={`/${location.hash}` === "/#introduction"}>
            <ListItemIcon>
              <AccountTreeOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Introduction" />
          </ListItemButton>
        </Link>

        <Link onClick={closeDrawer} to="/#api-development">
          <ListItemButton
            selected={`/${location.hash}` === "/#api-development"}
          >
            <ListItemIcon>
              <DataObjectOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="API Development Environment" />
          </ListItemButton>
        </Link>

        <Link onClick={closeDrawer} to="/#authentication">
          <ListItemButton selected={`/${location.hash}` === "/#authentication"}>
            <ListItemIcon>
              <LockPersonOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Authentication" />
          </ListItemButton>
        </Link>

        <Link onClick={closeDrawer} to="/#data-security">
          <ListItemButton selected={`/${location.hash}` === "/#data-security"}>
            <ListItemIcon>
              <RuleOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Data Security" />
          </ListItemButton>
        </Link>
      </List>
    );
  };

  const menuList = () => {
    return (
      <List
        dense
        sx={{ width: "100%" }}
        component="nav"
        subheader={
          <ListSubheader className="label-caps" id="nested-list-subheader">
            APIs
          </ListSubheader>
        }
      >
        {Object.keys(data.api_collection).map((item, index) => {
          return (
            <Link key={item} to={`/${item.split(" ").join("")}`}>
              <ListItemButton
                selected={location.pathname === `/${item.split(" ").join("")}`}
                onClick={() => {
                  setData((prevState) => ({
                    ...prevState,
                    drawer_open: false,
                  }));
                }}
              >
                <ListItemText primary={item} />
                <ListItemIcon>
                  <Chip
                    className="chips"
                    sx={{
                      background:
                        data.api_collection[
                          item
                        ]?.endpoint_method?.toLowerCase() === "get"
                          ? "#0e9b71"
                          : data.api_collection[
                              item
                            ]?.endpoint_method?.toLowerCase() === "delete"
                          ? "#ec6b6b"
                          : "#00bcd4",
                    }}
                    label={
                      data.api_collection[
                        item
                      ]?.endpoint_method?.toLowerCase() === "delete"
                        ? "del"
                        : data.api_collection[item]?.endpoint_method
                    }
                    size="small"
                  />
                </ListItemIcon>
              </ListItemButton>
            </Link>
          );
        })}

        <Divider sx={{ my: 1 }} />

        <Link
          onClick={() => {
            setData((prevState) => ({
              ...prevState,
              drawer_open: false,
            }));
          }}
          to="/ErrorCodes"
        >
          <ListItemButton selected={location.pathname === "/ErrorCodes"}>
            <ListItemText primary="Error Codes" />
          </ListItemButton>
        </Link>
      </List>
    );
  };

  return (
    <>
      <Box
        sx={{ display: { xs: "none", md: "initial" } }}
        className="sidebar"
        component="nav"
      >
        {topList()}
        {menuList()}
      </Box>

      {/* <Drawer
        sx={{
          display: { xs: "initial", md: "none" },
          "& .MuiDrawer-paper": {
            padding: { xs: "16px", sm: "32px" },
          },
        }}
        className="sidebar"
        open={data.drawer_open}
        onClose={() => {
          setData((prevState) => ({
            ...prevState,
            drawer_open: false,
          }));
        }}
      >
        <Toolbar sx={{ mb: "30px" }} />
        {topList()}
        {menuList()}
        <Toolbar />
      </Drawer> */}

      <Dialog
        TransitionComponent={Transition}
        className="sidebar"
        onClose={() => {
          setData((prevState) => ({
            ...prevState,
            drawer_open: false,
          }));
        }}
        open={data.drawer_open}
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            onClick={() => {
              setData((prevState) => ({
                ...prevState,
                drawer_open: false,
              }));
            }}
            sx={{ position: "absolute", right: 0, zIndex: 1200, top: 0 }}
          >
            <CloseIcon />
          </IconButton>
          {topList()}
          {menuList()}
        </Box>
      </Dialog>
    </>
  );
}

export default Sidebar;
